/**
 * PrimeLockButton — premium lock CTA shown where a PRIME Store purchase action
 * would normally sit. PRIME Charcoal face, champagne emblem + label, chevron.
 */
import { Crown, ChevronRight } from "lucide-react";

export function PrimeLockButton({ top, bottom, onClick, testid, compact = false, className = "" }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className={`group relative flex flex-1 items-center gap-3 overflow-hidden rounded-2xl border border-[#E4B66D]/35 bg-[#242521] text-left shadow-[0_4px_16px_-4px_rgba(36,37,33,0.5),0_0_0_1px_rgba(228,182,109,0.12)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#E4B66D]/60 hover:shadow-[0_10px_28px_-8px_rgba(36,37,33,0.55),0_0_24px_-6px_rgba(228,182,109,0.35)] active:translate-y-0 ${compact ? "h-11 px-3" : "h-14 px-4"} ${className}`}
    >
      {/* champagne sheen sweep on hover */}
      <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-[#E4B66D]/15 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
      <span className={`relative flex shrink-0 items-center justify-center rounded-xl bg-[#E4B66D]/15 text-[#E4B66D] ${compact ? "h-7 w-7" : "h-9 w-9"}`}>
        <Crown className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} strokeWidth={2.4} />
      </span>
      <span className="relative min-w-0 flex-1 leading-tight">
        <span className={`block font-extrabold uppercase tracking-[0.16em] text-[#E4B66D]/70 ${compact ? "text-[8px]" : "text-[9px]"}`}>{top}</span>
        <span className={`block truncate font-display font-bold tracking-tight text-[#E4B66D] ${compact ? "text-[13px]" : "text-[15px]"}`}>{bottom}</span>
      </span>
      <ChevronRight className={`relative shrink-0 text-[#E4B66D]/80 transition-transform duration-300 group-hover:translate-x-0.5 ${compact ? "h-3.5 w-3.5" : "h-4 w-4"}`} strokeWidth={2.5} />
    </button>
  );
}

